import { render } from "./MuddemalEdit.vue?vue&type=template&id=6a2bfe09&scoped=true"
import script from "./MuddemalEdit.vue?vue&type=script&lang=js"
export * from "./MuddemalEdit.vue?vue&type=script&lang=js"

import "./MuddemalEdit.vue?vue&type=style&index=0&id=6a2bfe09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2bfe09"]])

export default __exports__